import _ from 'lodash'
import { AutoComplete } from 'primereact/autocomplete'
import { useState } from 'react'

import { Input, Spinner } from '../../Components'
import { useAuth } from '../../Provider/AuthProvider'
import { FC } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { alert } from '../AdminCoefficient/Functions'
import { CardResult } from './CardResult'

const language = cap.language.state || 'IT'
const t = translations[language]

const checkDateFormat = (date) => /^\d{1,2}-\d{1,2}-\d{4}$/.test(date)
const checkHourFormat = (hour) => /^\d{1,2}:\d{1,2}$/.test(hour)

export const TrainServices = (type) => {
  const [departureDate, setDepartureDate] = useState('15-01-2024')
  const [departureHour, setDepartureHour] = useState('10:00')
  const {
    user: {
      user: {
        environment: { codSociety }
      }
    }
  } = useAuth()
  const [idCommunity, setIdCommunity] = useState(
    codSociety === '90'
      ? '26'
      : import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging'
        ? '87'
        : '1'
  )
  const [departureStation, setDepartureStation] = useState()
  const [suggestionsDepartureStation, setSuggestionsDepartureStation] = useState([])
  const [arrivalStation, setArrivalStation] = useState()
  const [suggestionsArrivalStation, setSuggestionsArrivalStation] = useState([])
  const [offerType, setOfferType] = useState('')
  const [results, setResults] = useState([])
  const [isSearching, setIsSearching] = useState(false)

  const debounceSearch = _.debounce(async (setter, query) => {
    if (query?.length < 3) return setter([])
    const res = await FC.service('info').get('getTrainStation', { query: { inputTrain: query } })
    setter(res)
  }, 450)

  const sendRequest = async () => {
    setResults([])
    if (!departureStation) return alert('error', t.tdStazionePartenzaNonValida)
    if (!arrivalStation) return alert('error', t.tdStazioneArrivoNonValida)
    if (!checkDateFormat(departureDate) || !checkHourFormat(departureHour))
      return alert('error', t.tdFormatoDataOraNonValido)
    setIsSearching(true)
    try {
      const res = await FC.service('info').create({
        action: 'previewDynResults',
        serviceType: 'Train',
        departureDate,
        departureHour,
        departureStation,
        arrivalStation,
        trainOffer: offerType,
        idCommunity
      })
      setResults(res)
    } catch (error) {
      alert('error', t.errore, error?.message || 'Errore durante la ricerca')
    } finally {
      setIsSearching(false)
    }
  }

  return (
    <div className="nsec" style={{ marginBottom: 16 }}>
      <div className="nsec__head">
        <div className="nsec__ico">
          <i className="pi pi-directions" style={{ fontSize: 16 }} />
        </div>
        <h3 className="nsec__title">{t.tdTreno}</h3>
        {results.length > 0 && (
          <span className="nbadge nbadge--info" style={{ marginLeft: 8 }}>
            {results.length} {t.tdRisultati}
          </span>
        )}
      </div>
      <div className="nsec__body">
        <div className="testdyn-filters-row">
          <div className="nfield">
            <label htmlFor="idCommunity">{t.tdIdCommunity}</label>
            <Input
              value={idCommunity}
              onChange={({ idCommunity }) => setIdCommunity(idCommunity)}
              id="idCommunity"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield">
            <label htmlFor="departureStation">{t.tdStazionePartenza}</label>
            <AutoComplete
              id="departureStation"
              onSelect={({ value: { stationName } }) => setDepartureStation(stationName)}
              field="stationName"
              value={departureStation}
              suggestions={suggestionsDepartureStation}
              completeMethod={({ query }) => debounceSearch(setSuggestionsDepartureStation, query)}
              onChange={(e) => setDepartureStation(e.value)}
              inputStyle={{ fontFamily: 'Lexend', width: '100%', borderRadius: 8 }}
              forceSelection
            />
          </div>
          <div className="nfield">
            <label htmlFor="arrivalStation">{t.tdStazioneArrivo}</label>
            <AutoComplete
              id="arrivalStation"
              onSelect={({ value: { stationName } }) => setArrivalStation(stationName)}
              field="stationName"
              value={arrivalStation}
              suggestions={suggestionsArrivalStation}
              completeMethod={({ query }) => debounceSearch(setSuggestionsArrivalStation, query)}
              onChange={(e) => setArrivalStation(e.value)}
              inputStyle={{ fontFamily: 'Lexend', width: '100%', borderRadius: 8 }}
              forceSelection
            />
          </div>
          <div className="nfield">
            <label htmlFor="offerType">{t.tdClasse}</label>
            <Input
              id="offerType"
              dropdown
              options={['Executive', 'Business', 'Premium', 'Standard', '']}
              value={offerType}
              onChange={({ offerType }) => setOfferType(offerType)}
              style={{ width: '100%' }}
              onEnter={sendRequest}
            />
          </div>
          <div className="nfield">
            <label htmlFor="departureDate">{t.tdDataPartenza}</label>
            <Input
              value={departureDate}
              onChange={({ departureDate }) => setDepartureDate(departureDate)}
              id="departureDate"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield">
            <label htmlFor="departureHour">{t.tdOraPartenza}</label>
            <Input
              value={departureHour}
              onChange={({ departureHour }) => setDepartureHour(departureHour)}
              id="departureHour"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          {isSearching ? (
            <Spinner />
          ) : (
            <button type="button" className="nbtn nbtn--primary" onClick={sendRequest}>
              <i className="pi pi-search" style={{ fontSize: 14 }} />
              {t.tdCerca}
            </button>
          )}
        </div>
      </div>
      {results.length > 0 && (
        <div className="nsec__body nsec__body--flush">
          <table className="ntable">
            <thead>
              <tr>
                <th>{t.tdTipo}</th>
                <th>{t.tdPartenza}</th>
                <th>{t.tdArrivo}</th>
                <th style={{ width: 120 }}>{t.tdTariffa}</th>
                <th style={{ width: 100, textAlign: 'right' }}>{t.tdPrezzo}</th>
              </tr>
            </thead>
            <tbody>
              {results.map((result, index) => {
                const route = result?.routes?.[0] || {}
                return (
                  <tr key={index}>
                    <td>
                      <span
                        style={{ fontFamily: 'var(--font-mono)', fontSize: 12.5, fontWeight: 600 }}
                      >
                        {route.typeTrenoDescription || result.quoteType}
                      </span>
                    </td>
                    <td>
                      <span className="ntable__meta">{route.labelStationDeparture}</span>
                    </td>
                    <td>
                      <span className="ntable__meta">{route.labelStationArrival}</span>
                    </td>
                    <td>
                      <span className="nbadge">{route.classTrain}</span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <span className="ntable__num" style={{ fontWeight: 600 }}>
                        €{result.price}
                      </span>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="testdyn-results-grid">
        {results.map((result, index) => (
          <CardResult key={index} result={result} type={result?.serviceType} />
        ))}
      </div>
    </div>
  )
}
